import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Button, DialogActions, Divider, Grid, TextField, DialogContent, Typography, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import "./CreateAgentDialog.css";
import _ from "lodash";
import { toast } from 'react-toastify';
import UploadIcon from '@mui/icons-material/Upload';
import {AGENT_CONFIG_SUMMARY, DELETE_AGENT_CONFIG} from "../../../actions/types"
import { createAgentServiceVlan, getAgentServiceVlans, getAgentRoutes, getAgentServices, verifyAgentConfig, updateUploadAgentConfig, gethub4AgentConfigSummary, getAgents } from "../../../actions/Users/authenticateHub";
import { CREATE_AGENT_ACCESS_NETWORK, UPDATE_AGENT_ACCESS_NETWORK } from "../../../actions/types";
import CustomLoader from "../../../components/Loader/CustomLoader";
import NewDownloadButton from '../../../asset/image/NewDownloadButton.svg';
import axios from 'axios';

export const AccessNetworkPopup = (props) => {
    const dispatch = useDispatch();
    const { authReducer, getAgentServiceVlans, getAgentServices, setIsActionPopup, isEditActionPopup, verifyAgentConfig, updateUploadAgentConfig, gethub4AgentConfigSummary, agentId, setAgentId, agentName, setAgentName, getAgents, selectedDp, actionsList, setSelectedAction, uploadedFile, setUploadedFile, currentAgentName, enableNextButton, setEnableNextButton } = props;

    const [routeItems, setRouteItems] = useState<any[]>([])
    const [services, setServices] = useState<any>([])
    const [serviceVlanItems, setServiceVlanItems] = useState<any[]>([])
    const [selectedValue, setSelectedValue] = useState<any>(null)
    const [serviceVlans, setServiceVlans] = useState<any>([])
    const [verifyError, setVerifyError] = useState('');
    

    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: "",
        subTitle: "",
        onConfirm: {},
    });
    
    

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            event.target.value = '';
            setUploadedFile(file);
        }
    };

   


    const handleRouteItems = (items: any) => {
        let existingRouteItems: any = []
        if (items?.length) {
            for (let index in items) {
                let item = items[index]
                existingRouteItems.push({ ...item, id: parseInt(index) })
            }
        }
        setRouteItems(existingRouteItems)
    }

    useEffect(() => {
        if(agentId && uploadedFile){
            const payload = new FormData();
            payload.append('agent_id', agentId);
            payload.append('agent_name', agentName ? agentName : agentId);
            payload.append('create_new', isEditActionPopup ? 'false' : 'true');
            if(uploadedFile) {
                payload.append('file', uploadedFile);
            }
            verifyAgentConfig(selectedDp?.id, payload)
        }
    }, [uploadedFile])

    const handleNext = () => {
        // if (isEditActionPopup) {
        //     updateUploadAgentConfig(selectedDp?.id, agentId, payload)
        // } else {
            // verifyAgentConfig(selectedDp?.id, payload)
        // }
        setSelectedAction(actionsList[1]);
        dispatch({ type: AGENT_CONFIG_SUMMARY, payload: {}});
    }

    const handleClose = () => {
        setIsActionPopup(false)
    }

    const handleClear = () => {
        setServiceVlanItems([])
        setSelectedValue(null)
    }

    useEffect(() => {
        if (!_.isEmpty(authReducer?.verifyAgentConfig) && !authReducer?.verifyAgentConfigLoading) {
            // gethub4AgentConfigSummary(selectedDp?.id, agentId)
            // getAgents(selectedDp?.id)
            // toast.success("Agent config has been created successfully", { position: toast.POSITION.BOTTOM_LEFT })
            dispatch({ type: CREATE_AGENT_ACCESS_NETWORK, payload: {} })
            setEnableNextButton(true);
            handleClear()
            setVerifyError(authReducer?.verifyAgentConfig?.verifyError);
        } else if(_.isEmpty(authReducer?.verifyAgentConfig)) {
            setEnableNextButton(false);
        }
    }, [authReducer?.verifyAgentConfigLoading, authReducer?.verifyAgentConfig])

    useEffect(() => {
        if (!_.isEmpty(authReducer?.updateUploadAgentConfig) && !authReducer?.updateUploadAgentConfigLoading) {
            gethub4AgentConfigSummary(selectedDp?.id, agentId)
            getAgents(selectedDp?.id, {'isHub4': true})
            toast.success("Agent config has been updated successfully", { position: toast.POSITION.BOTTOM_LEFT })
            dispatch({ type: UPDATE_AGENT_ACCESS_NETWORK, payload: {} })

            handleClear()
        };
    }, [authReducer?.updateUploadAgentConfigLoading, authReducer?.updateUploadAgentConfig])

    useEffect(() => {
        if (!_.isEmpty(authReducer?.getAgentServices) && !authReducer?.getAgentServicesLoading) {
            setServices(authReducer?.getAgentServices?.configured_services || [])
        }
    }, [authReducer?.getAgentServices])


    const TEMPLATE_URL = 'https://cdn.k4mobility.com/cdn/HUB/ConfigTemplate/agent_config_v3_template.yml';

    const handleDownloadTemplate = async () => {
    try {
        const response = await fetch(TEMPLATE_URL);
        const blob = await response.blob();
        const renamedBlob = new Blob([blob], { type: 'application/x-yaml' });

        const url = window.URL.createObjectURL(renamedBlob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'agent_config_template.yaml';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Failed to download the template file:', error);
    }
    };


    return (
        <Grid>
            <DialogContent style={{ paddingBottom: "10%", position: "relative", padding: "20px", minHeight: "400px" }}>
                <Grid container className="deploy-inventory-content register-inventory-content">
                    <Grid container className="config-apply-config-target uploadFileAgent">
                        <Grid className="uploadSelectText">Agent ID</Grid>
                        <Grid xs={4} sm={4} md={4} lg={4}>
                            <TextField
                                className="hub-config-hub-ip"
                                placeholder="Agent ID*"
                                value={agentId}
                                onChange={(event) => { setAgentId(event?.target?.value) }}
                                variant="outlined"
                                size="small"
                                disabled={isEditActionPopup ? true : false}
                            />
                        </Grid>
                    </Grid>
                    <Grid container className="config-apply-config-target uploadFileAgent" style={{ marginTop: "10px", marginBottom: "10px" }}>
                        <Grid className="uploadSelectText">Agent Name</Grid>
                        <Grid xs={4} sm={4} md={4} lg={4}>
                            <TextField
                                className="hub-config-hub-ip"
                                placeholder="Agent Name"
                                value={agentName}
                                onChange={(event) => { setAgentName(event?.target?.value) }}
                                variant="outlined"
                                size="small"
                                disabled={false}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <div className="p-4 space-y-4">
                    <div className="uploadText">
                        Download Template:{' '}
                        <a target="_blank" href="https://cdn.k4mobility.com/cdn/HUB/ConfigTemplate/agent_config_v3_template.yml" className="text-blue-600 hover:underline" style={{ color: 'blue' }}>
                        agent_config_template
                        </a>
                        <div className="displayFlex">
                            <Tooltip title='Download'><img id="downloadIcon" src={NewDownloadButton} alt="" onClick={handleDownloadTemplate}/></Tooltip>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <input
                            key={uploadedFile?.name}
                            accept=".yaml"
                            style={{ display: 'none' }}
                            id="upload-button-file"
                            type="file"
                            onChange={handleFileChange}
                        />
                        <label
                            htmlFor="upload-button-file"
                            onClick={(e) => {
                                if (agentId === "") {
                                    e.preventDefault();
                                }
                            }}
                        >
                            <Button
                                variant="outlined"
                                component="span"
                                disabled={agentId === ""}
                                startIcon={<UploadIcon />}
                                className="uploadButton"
                                sx={{
                                    textTransform: 'none',
                                    fontSize: '0.875rem',
                                    padding: '4px 12px',
                                }}
                            >
                                Upload
                            </Button>
                        </label>

                        {uploadedFile && enableNextButton && (
                            <Typography
                                variant="body2"
                                sx={{ color: '#1976d2', fontWeight: 500, cursor: 'pointer' }}
                            >
                                {uploadedFile.name}
                            </Typography>
                        )}
                    </div>
                    {uploadedFile && !authReducer.verifyAgentConfigLoading && !_.isEmpty(authReducer?.verifyAgentConfig) && (
                        <Typography
                            variant="body2"
                            sx={{
                                color: enableNextButton ? 'green' : 'red',
                                fontWeight: 500,
                                marginTop: '8px',
                            }}
                        >
                            {enableNextButton
                                ? '✅ Agent Config file uploaded and validated successfully.'
                                : '❌ Failed to upload or validate the Agent Config file. Please try again.'}
                        </Typography>
                    )}
                    {verifyError &&
                        <pre
                            style={{
                                color: 'red',
                                fontWeight: 500,
                                marginTop: '8px',
                            }}
                        >
                            {verifyError}
                        </pre>
                    }
                    </div>
            </DialogContent>
            <DialogActions>
                <Divider className="threatKontrolDivider" />
                <div className="displayFlex threatKontrolMargin">
                    <Button className="confirm-dialogue-cancel" style={{ color: "#264c86" }} onClick={() => { handleClose() }}> Cancel </Button>
                    <Button variant="contained" 
                    style={{ background: agentId && enableNextButton && uploadedFile ? "#264C86" : "#E8F0FD",
                        color: agentId && enableNextButton && uploadedFile ? "#fff" : "#264C86" }}
                        disabled={agentId && enableNextButton && uploadedFile ? false : true}
                         onClick={() => { handleNext() }}>Next</Button>
                </div>
            </DialogActions>
            {authReducer.verifyAgentConfigLoading ? (
                <CustomLoader
                    showLoader={true}
                    loadingText={"Uploading and processing YAML file… Please wait."}
                />
            ) : null
            }
        </Grid>
    )
}


const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
});

export default withRouter(
    connect(mapStateToProps, {
        createAgentServiceVlan,
        getAgentServiceVlans,
        getAgentRoutes,
        getAgentServices,
        verifyAgentConfig,
        updateUploadAgentConfig,
        gethub4AgentConfigSummary,
        getAgents
    })(AccessNetworkPopup)
);